// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Digital7Italic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Digital-7';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
.custom-popup {
    background-color: transparent;
    /* border: 1px solid #ccc; */
    /* padding: 10px; */
    border-radius: var(--border-radios-small) ;
    font-size: var(--font-size-xSmall) !important;
    font-weight: bold;
    width: auto;
    height: auto;
    
  }
  /* .mapboxgl-map{
    z-index: -1 !important;
  } */
  /* Estilos para la clase "poop" dentro del contenido del popup */
  .cont-pop {
    background-color: var(--white-color) !important;
    /* font-weight: bold; */
    border-radius: var(--border-radios-small) !important;
    width: 100%;
    height: 100%;
    position: relative;
    /* padding: 3px; */

  }
.mapboxgl-popup-content{
    /* border: 1px solid #ccc !important; */
    /* background-color: rgba(4, 23, 24, 0.89) !important;  */
    background-color: transparent !important; 
    color: var(--txt-color) !important;
    font-size: var(--font-size-xSmall) !important;
    font-weight: unset !important;
    width: auto;
    height: auto;
    padding: unset !important;
    text-align: center !important;
}

.custom-popup-rfid {
  font-weight: bold;
  width: auto !important;
  height: 7% !important;;
  position: relative;
  padding: 3px;

}
.custom-popup-rfid .mapboxgl-popup-content {
  
  width: 100%;
  height: 100%;
  position: relative;
  /* padding: 3px; */
 /* background-color: rgba(228, 228, 228, 0.774) !important;  */
 background-color: rgba(20, 20, 20, 0.904) !important; 

  top: 2%;
  min-width: 40px;
 width: auto;
 height: auto;
 padding: unset !important;
 border-radius: 0px 0px 10px 10px;
}
.cont-rfid {
  font-weight: bold;
  border-radius: 0px 0px 10px 10px;
  position: relative;
  /* padding: 3px; */
  display: block;
  justify-content: center;
  height: 30px !important;
}
.titleRFID{
  background-color: aliceblue;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 0px 0px 0px;
  height: 30%;
}
.txtTitleRfid{
font-size: x-small;
margin: 2%;
color: rgb(26, 25, 25);
}

.valRFID{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70%;
  border-radius: 0px 0px 10px 10px;
  font-family: 'Digital-7', sans-serif;
  
}
.txtRfid{
  /* color: rgb(17, 26, 51) !important; */
  /* color:rgb(46, 46, 46) !important ; */
  color:limegreen !important ;
  font-size: medium;
  font-weight: bold;
 text-align: center !important;
 width: auto;
 height: 100%;
 display: flex;
 justify-content: center;
 align-items: center;
}
/***************************LPR*********************************/
.custom-popup-lpr {
  font-weight: bold;
  width: auto !important;
  height: 7% !important;;
  position: relative;
  padding: 3px;

}
.custom-popup-lpr .mapboxgl-popup-content {
  
  width: 100%;
  height: 100%;
  position: relative;
  /* padding: 3px; */
 /* background-color: rgba(228, 228, 228, 0.774) !important;  */
 background-color: rgba(158, 157, 157, 0.781) !important; 

  top: 2%;
  min-width: 50px;
 width: auto;
 height: auto;
 padding: unset !important;
 border-radius: 20px 20px 20px 20px;
}
.cont-lpr {
  font-weight: bold;
  border-radius: 20px 20px 20px 20px;
  position: relative;
  /* padding: 3px; */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px !important;
}
.titleLPR{
  display: none;
  background-color: aliceblue;
  position: relative;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  border-radius: 0px 0px 0px 0px;
  height: 30%;
}
.txtTitleLpr{
  
font-size: x-small;
margin: 2%;
color: rgb(26, 25, 25);
}

.valLPR{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
  width: 80%;
  border-radius: 20px 20px 20px 20px;
  font-family: 'Digital-7', sans-serif;
  background-color: rgba(20, 20, 20, 0.904);
}
.txtLpr{
  /* color: rgb(17, 26, 51) !important; */
  /* color:rgb(46, 46, 46) !important ; */
  color:limegreen !important ;
  font-size: medium;
  font-weight: bold;
 text-align: center !important;
 width: auto;
 height: 100%;
 display: flex;
 justify-content: center;
 align-items: center;
}

/***************************except*********************************/
.custom-popup-except {
  font-weight: bold;
  width: auto !important;
  height: 7% !important;;
  position: relative;
  padding: 3px;

}
.custom-popup-except .mapboxgl-popup-content {
  
  width: 100%;
  height: 100%;
  position: relative;
  /* padding: 3px; */
 /* background-color: rgba(228, 228, 228, 0.774) !important;  */
 /* background-color: rgba(158, 157, 157, 0.781) !important;  */

  top: 2%;
  min-width: 50px;
 width: auto;
 height: auto;
 padding: unset !important;
 /* border-radius: 20px 20px 20px 20px; */
}
.cont-except {
  /* font-weight: bold; */
  /* border-radius: 20px 20px 20px 20px; */
  position: relative;
  /* padding: 3px; */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px !important;
  border-radius: var(--border-radios-small);
  /* width: 40px !important; */
}
.titleexcept{
  display: none;
  background-color: aliceblue;
  position: relative;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  /* border-radius: 0px 0px 0px 0px; */
  height: 30%;
}
.txtTitleexcept{
  
font-size: x-small;
margin: 2%;
color: rgb(26, 25, 25);
}

.valexcept{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  /* border-radius: 20px 20px 20px 20px; */
  /* font-family: 'Digital-7', sans-serif; */
  /* background-color: rgba(255, 255, 255, 0.904); */
  border-radius: var(--border-radios-small);
}


.txtexcept{
  /* color: rgb(17, 26, 51) !important; */
  /* color:rgb(46, 46, 46) !important ; */
  color:var(--white-color) !important ;
  font-size: var(--font-size-xSmall);
  font-weight: bold;
 text-align: center !important;
 width: auto;
 height: 100%;
 display: flex;
 justify-content: center;
 align-items: center;
}



.pulsing-dot-element {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulsate 1s infinite alternate;
}

@keyframes pulsate {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}


/**********************************white****************************************/
.custom-popup-except-white {
  font-weight: bold;
  width: auto !important;
  height: 7% !important;
  position: relative;
  padding: 3px;
}
.custom-popup-except-white .mapboxgl-popup-content {
  
  width: 100%;
  height: 100%;
  position: relative;
  /* padding: 3px; */
 /* background-color: rgba(228, 228, 228, 0.774) !important;  */
 background-color: rgba(158, 157, 157, 0.781) !important; 

  top: 2%;
  min-width: 50px;
 width: auto;
 height: auto;
 padding: unset !important;
 /* border-radius: 20px 20px 20px 20px; */
}
.custom-popup-except-white .mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip{
  border-top-color: #a2a2a2 !important;
}
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip{
  border-top-color: #a2a2a2 !important;
}
.custom-popup-except-white.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip{
  border-top-color: rgb(189, 189, 189) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/MapBox.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,+DAA0D;AAC5D;AACA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,mBAAmB;IACnB,0CAA0C;IAC1C,6CAA6C;IAC7C,iBAAiB;IACjB,WAAW;IACX,YAAY;;EAEd;EACA;;KAEG;EACH,gEAAgE;EAChE;IACE,+CAA+C;IAC/C,uBAAuB;IACvB,oDAAoD;IACpD,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;;EAEpB;AACF;IACI,uCAAuC;IACvC,yDAAyD;IACzD,wCAAwC;IACxC,kCAAkC;IAClC,6CAA6C;IAC7C,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;;AAEd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;CACnB,8DAA8D;CAC9D,oDAAoD;;EAEnD,OAAO;EACP,eAAe;CAChB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,gCAAgC;AACjC;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;AACA,kBAAkB;AAClB,UAAU;AACV,sBAAsB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,oCAAoC;;AAEtC;AACA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;CAClB,6BAA6B;CAC7B,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA,gEAAgE;AAChE;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;;AAEd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;CACnB,8DAA8D;CAC9D,uDAAuD;;EAEtD,OAAO;EACP,eAAe;CAChB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kCAAkC;AACnC;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;;AAEA,kBAAkB;AAClB,UAAU;AACV,sBAAsB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kCAAkC;EAClC,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;CAClB,6BAA6B;CAC7B,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;;AAEd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;CACnB,8DAA8D;CAC9D,8DAA8D;;EAE7D,OAAO;EACP,eAAe;CAChB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,wCAAwC;AACzC;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;AACb;AACA;;AAEA,kBAAkB;AAClB,UAAU;AACV,sBAAsB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,0CAA0C;EAC1C,kDAAkD;EAClD,yCAAyC;AAC3C;;;AAGA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;EAClC,iBAAiB;CAClB,6BAA6B;CAC7B,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;;;AAIA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;;AAGA,gFAAgF;AAChF;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;CACnB,8DAA8D;CAC9D,uDAAuD;;EAEtD,OAAO;EACP,eAAe;CAChB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,wCAAwC;AACzC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,+CAA+C;AACjD","sourcesContent":["@font-face {\r\n  font-family: 'Digital-7';\r\n  src: url('../fonts/Digital7Italic.ttf') format('truetype');\r\n}\r\n.custom-popup {\r\n    background-color: transparent;\r\n    /* border: 1px solid #ccc; */\r\n    /* padding: 10px; */\r\n    border-radius: var(--border-radios-small) ;\r\n    font-size: var(--font-size-xSmall) !important;\r\n    font-weight: bold;\r\n    width: auto;\r\n    height: auto;\r\n    \r\n  }\r\n  /* .mapboxgl-map{\r\n    z-index: -1 !important;\r\n  } */\r\n  /* Estilos para la clase \"poop\" dentro del contenido del popup */\r\n  .cont-pop {\r\n    background-color: var(--white-color) !important;\r\n    /* font-weight: bold; */\r\n    border-radius: var(--border-radios-small) !important;\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    /* padding: 3px; */\r\n\r\n  }\r\n.mapboxgl-popup-content{\r\n    /* border: 1px solid #ccc !important; */\r\n    /* background-color: rgba(4, 23, 24, 0.89) !important;  */\r\n    background-color: transparent !important; \r\n    color: var(--txt-color) !important;\r\n    font-size: var(--font-size-xSmall) !important;\r\n    font-weight: unset !important;\r\n    width: auto;\r\n    height: auto;\r\n    padding: unset !important;\r\n    text-align: center !important;\r\n}\r\n\r\n.custom-popup-rfid {\r\n  font-weight: bold;\r\n  width: auto !important;\r\n  height: 7% !important;;\r\n  position: relative;\r\n  padding: 3px;\r\n\r\n}\r\n.custom-popup-rfid .mapboxgl-popup-content {\r\n  \r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  /* padding: 3px; */\r\n /* background-color: rgba(228, 228, 228, 0.774) !important;  */\r\n background-color: rgba(20, 20, 20, 0.904) !important; \r\n\r\n  top: 2%;\r\n  min-width: 40px;\r\n width: auto;\r\n height: auto;\r\n padding: unset !important;\r\n border-radius: 0px 0px 10px 10px;\r\n}\r\n.cont-rfid {\r\n  font-weight: bold;\r\n  border-radius: 0px 0px 10px 10px;\r\n  position: relative;\r\n  /* padding: 3px; */\r\n  display: block;\r\n  justify-content: center;\r\n  height: 30px !important;\r\n}\r\n.titleRFID{\r\n  background-color: aliceblue;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 0px 0px 0px 0px;\r\n  height: 30%;\r\n}\r\n.txtTitleRfid{\r\nfont-size: x-small;\r\nmargin: 2%;\r\ncolor: rgb(26, 25, 25);\r\n}\r\n\r\n.valRFID{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 70%;\r\n  border-radius: 0px 0px 10px 10px;\r\n  font-family: 'Digital-7', sans-serif;\r\n  \r\n}\r\n.txtRfid{\r\n  /* color: rgb(17, 26, 51) !important; */\r\n  /* color:rgb(46, 46, 46) !important ; */\r\n  color:limegreen !important ;\r\n  font-size: medium;\r\n  font-weight: bold;\r\n text-align: center !important;\r\n width: auto;\r\n height: 100%;\r\n display: flex;\r\n justify-content: center;\r\n align-items: center;\r\n}\r\n/***************************LPR*********************************/\r\n.custom-popup-lpr {\r\n  font-weight: bold;\r\n  width: auto !important;\r\n  height: 7% !important;;\r\n  position: relative;\r\n  padding: 3px;\r\n\r\n}\r\n.custom-popup-lpr .mapboxgl-popup-content {\r\n  \r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  /* padding: 3px; */\r\n /* background-color: rgba(228, 228, 228, 0.774) !important;  */\r\n background-color: rgba(158, 157, 157, 0.781) !important; \r\n\r\n  top: 2%;\r\n  min-width: 50px;\r\n width: auto;\r\n height: auto;\r\n padding: unset !important;\r\n border-radius: 20px 20px 20px 20px;\r\n}\r\n.cont-lpr {\r\n  font-weight: bold;\r\n  border-radius: 20px 20px 20px 20px;\r\n  position: relative;\r\n  /* padding: 3px; */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 30px !important;\r\n}\r\n.titleLPR{\r\n  display: none;\r\n  background-color: aliceblue;\r\n  position: relative;\r\n  /* display: flex; */\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 0px 0px 0px 0px;\r\n  height: 30%;\r\n}\r\n.txtTitleLpr{\r\n  \r\nfont-size: x-small;\r\nmargin: 2%;\r\ncolor: rgb(26, 25, 25);\r\n}\r\n\r\n.valLPR{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 80%;\r\n  width: 80%;\r\n  border-radius: 20px 20px 20px 20px;\r\n  font-family: 'Digital-7', sans-serif;\r\n  background-color: rgba(20, 20, 20, 0.904);\r\n}\r\n.txtLpr{\r\n  /* color: rgb(17, 26, 51) !important; */\r\n  /* color:rgb(46, 46, 46) !important ; */\r\n  color:limegreen !important ;\r\n  font-size: medium;\r\n  font-weight: bold;\r\n text-align: center !important;\r\n width: auto;\r\n height: 100%;\r\n display: flex;\r\n justify-content: center;\r\n align-items: center;\r\n}\r\n\r\n/***************************except*********************************/\r\n.custom-popup-except {\r\n  font-weight: bold;\r\n  width: auto !important;\r\n  height: 7% !important;;\r\n  position: relative;\r\n  padding: 3px;\r\n\r\n}\r\n.custom-popup-except .mapboxgl-popup-content {\r\n  \r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  /* padding: 3px; */\r\n /* background-color: rgba(228, 228, 228, 0.774) !important;  */\r\n /* background-color: rgba(158, 157, 157, 0.781) !important;  */\r\n\r\n  top: 2%;\r\n  min-width: 50px;\r\n width: auto;\r\n height: auto;\r\n padding: unset !important;\r\n /* border-radius: 20px 20px 20px 20px; */\r\n}\r\n.cont-except {\r\n  /* font-weight: bold; */\r\n  /* border-radius: 20px 20px 20px 20px; */\r\n  position: relative;\r\n  /* padding: 3px; */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 20px !important;\r\n  border-radius: var(--border-radios-small);\r\n  /* width: 40px !important; */\r\n}\r\n.titleexcept{\r\n  display: none;\r\n  background-color: aliceblue;\r\n  position: relative;\r\n  /* display: flex; */\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* border-radius: 0px 0px 0px 0px; */\r\n  height: 30%;\r\n}\r\n.txtTitleexcept{\r\n  \r\nfont-size: x-small;\r\nmargin: 2%;\r\ncolor: rgb(26, 25, 25);\r\n}\r\n\r\n.valexcept{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 100%;\r\n  /* border-radius: 20px 20px 20px 20px; */\r\n  /* font-family: 'Digital-7', sans-serif; */\r\n  /* background-color: rgba(255, 255, 255, 0.904); */\r\n  border-radius: var(--border-radios-small);\r\n}\r\n\r\n\r\n.txtexcept{\r\n  /* color: rgb(17, 26, 51) !important; */\r\n  /* color:rgb(46, 46, 46) !important ; */\r\n  color:var(--white-color) !important ;\r\n  font-size: var(--font-size-xSmall);\r\n  font-weight: bold;\r\n text-align: center !important;\r\n width: auto;\r\n height: 100%;\r\n display: flex;\r\n justify-content: center;\r\n align-items: center;\r\n}\r\n\r\n\r\n\r\n.pulsing-dot-element {\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  animation: pulsate 1s infinite alternate;\r\n}\r\n\r\n@keyframes pulsate {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n  100% {\r\n    transform: scale(1.1);\r\n  }\r\n}\r\n\r\n\r\n/**********************************white****************************************/\r\n.custom-popup-except-white {\r\n  font-weight: bold;\r\n  width: auto !important;\r\n  height: 7% !important;\r\n  position: relative;\r\n  padding: 3px;\r\n}\r\n.custom-popup-except-white .mapboxgl-popup-content {\r\n  \r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  /* padding: 3px; */\r\n /* background-color: rgba(228, 228, 228, 0.774) !important;  */\r\n background-color: rgba(158, 157, 157, 0.781) !important; \r\n\r\n  top: 2%;\r\n  min-width: 50px;\r\n width: auto;\r\n height: auto;\r\n padding: unset !important;\r\n /* border-radius: 20px 20px 20px 20px; */\r\n}\r\n.custom-popup-except-white .mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip{\r\n  border-top-color: #a2a2a2 !important;\r\n}\r\n.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip{\r\n  border-top-color: #a2a2a2 !important;\r\n}\r\n.custom-popup-except-white.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip{\r\n  border-top-color: rgb(189, 189, 189) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
